import { Outlet } from "react-router-dom"

const BookingPage = () => {
    return (
        <Outlet />
    );
};

export default BookingPage;
